<script setup>
import LoadingDummySelect from '@/assets/js/src/components/loading/LoadingDummySelect'
import { toRefs, } from 'vue'
import { useMessagesLoaded, } from '@/assets/js/src/modules/lang/_composables/useMessagesLoaded'
import { useTranslation, } from '@/assets/js/src/util/composables/useTranslation'

const debouncedSearch = defineModel({
    type: String,
    required: true,
})

const props = defineProps({
    labelKey: {
        type: String,
        default: '',
    },
})

const { labelKey, } = toRefs(props)
const { messagesLoaded, } = useMessagesLoaded([ labelKey.value.split('.')[1] ?? 'resource', ])
const { t, } = useTranslation()
</script>

<template>
    <div class="mb-7">
        <v-text-field
            v-if="messagesLoaded"
            v-model="debouncedSearch"
            variant="solo"
            flat
            hide-details
            :placeholder="t(labelKey)"
            :aria-label="t(labelKey)"
            prepend-inner-icon="bs:$vuetify.icons.mdiMagnify"
        ></v-text-field>
        <loading-dummy-select
            v-else
        ></loading-dummy-select>
    </div>
</template>
